import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotFound, RouteWithSubRoutes } from '@cordata/buffet';

import Index from './collection';

const Providers = ({ routes }) => {
  const { url, path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          exact
          path={url}
          render={() => <Index />}
        />

        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </>
  );
};

export default Providers;
